var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg3288",
    xmlSpace: "preserve",
    width: 300,
    height: 300,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3302"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    fill: "#c72538",
    stroke: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3302)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(309.6295,135.1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 16.188,-45.052 -15.536,-97.688 -70.858,-117.567 -55.323,-19.879 -113.294,0.528 -129.482,45.579 -16.188,45.052 15.536,97.688 70.858,117.567 C -74.159,65.458 -16.188,45.052 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.8524,348.2414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 75.763 c 0,13.255 10.745,24 24,24 v 0 c 13.255,0 24,-10.745 24,-24 v -314.037",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.8524,181.5048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 76.737",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.4774,334.3568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 45.92,-0.118 88.791,-13.181 125.171,-35.728 7.598,-4.709 16.946,2.427 14.462,11.015 C 122.088,35.955 66.256,80.363 0,80.642",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.3692,371.6354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -4.83,-30.932 c -1.299,-8.318 -12.495,-10.092 -16.301,-2.582 l -14.152,27.926 -31.01,-4.981 c -8.303,-1.334 -13.452,8.746 -7.506,14.692 l 22.208,22.208 -14.228,27.821 c -3.831,7.49 4.177,15.498 11.667,11.667 l 27.821,-14.228 22.208,22.208 c 5.946,5.946 16.026,0.797 14.692,-7.506 L 5.588,35.283 33.514,21.131 C 41.024,17.325 39.25,6.129 30.932,4.83 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440.0861,103.2333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -25.288,-18.457 c -6.8,-4.964 -15.971,1.7 -13.352,9.701 l 9.74,29.753 -25.45,18.406 c -6.814,4.928 -3.328,15.696 5.081,15.696 h 31.408 l 9.611,29.733 c 2.587,8.005 13.913,8.005 16.5,0 l 9.611,-29.733 h 31.408 c 8.409,0 11.895,-10.768 5.081,-15.696 L 28.9,20.997 38.64,-8.756 c 2.619,-8.001 -6.552,-14.665 -13.352,-9.701 z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(454.519,421.9859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,19.627 -15.911,35.538 -35.538,35.538",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(499.0002,421.9859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,44.193 -35.826,80.019 -80.019,80.019",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4561,189.9523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -19.627,0 -35.538,-15.911 -35.538,-35.538",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.4561,234.4334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -44.193,0 -80.019,-35.826 -80.019,-80.019",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.8524,303.2418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#c72538",
    strokeWidth: 20
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.dbd35ffa453eef859a9f7880d51b09b4.svg";
export { ForwardRef as ReactComponent };